import { BaseService } from '../../services/base.service';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: "root"  // **** ADD THIS LINE ****
})
export class Func {
    errors = new Array();
    constructor(public baseService: BaseService, private translate: TranslateService, ) {
        
    }

    _uid = null;
    public s =" ";
    
    WriteName() {

        if (this.baseService.LoggedUser != null) {
            this.translate.get('assistance-form.hellow').subscribe((text: string) => { this.s = text; });
            this.s += " ";
            if (this.baseService.LoggedUser.MIN == '1')
                this.translate.get('assistance-form.Mr').subscribe((text: string) => { this.s += text; });
            else if (this.baseService.LoggedUser.MIN == '2')
                this.translate.get('assistance-form.Mrs').subscribe((text: string) => { this.s += text; });
            this.s += " ";

            this.s += this.baseService.LoggedUser.SHEM_PRATI + " " + this.baseService.LoggedUser.SHEM_MISHPAHA + ",";
            return true;
        }
        else return false;
    }

    
    //valid uid
    public checkUid(uid: string) {     
        if (uid == null) {//if the uid not saved in the session
            this._uid = 0;
           return  'assistance-form.errors.DirectlyErr';             
        }
        
        if (!Number(uid))//if isnt a number
        {
            this._uid = 0;
            return 'assistance-form.errors.invalidUidErr';
        }
        try {
            this.baseService.isExists(uid).subscribe(data => {
                this.baseService.exsist = data;
                if (this.baseService.exsist)//if the uid exsist in hozrim_kelet_taas_v
                {
                    return 'assistance-form.errors.secondTimeErr';
                }

            });
            if (!(this.baseService.LoggedUser.MISPAR_ZEHUT != '0' && this.baseService.LoggedUser.MISPAR_ZEHUT != '' && this.baseService.LoggedUser.MISPAR_ZEHUT != null)) {
               return 'assistance-form.errors.istIsraelyErr';
            }
            if (!this.WriteName()) {
                return 'assistance-form.errors.notExsistUidErr';
            }

        }
        catch (Exception) {
            return 'assistance-form.errors.dataErr';
        }
    }

    public encrypt (str: string): string {
        let s = btoa(str).split('').join('');
        let len = s.length;
        let checksum = 0;
        let res = btoa(len.toString()) + s;
        for (let i=0; i < str.length; i++) 
        {
            checksum = checksum + str.charCodeAt(i);
        }
        res = res + btoa(checksum.toString());
        res = res.split('=').join('#');
        return res;
    }

    public decrypt (str: string): string {
        let res = str.split('#').join('=');
        let len = Number(atob(res.substr(0, 4)));
        let s = atob(res.substr(4, len).split('').join(''));
        let checkstr = res.substr(len+4);
        checkstr = atob(checkstr);
        let checksum = 0;
        for (let i=0; i < s.length; i++) 
        {
            checksum += s.charCodeAt(i);
        }
        if (checksum != Number(checkstr))
            throw (new Error ("Invalid checksum"));
        return  s;
    }
}